import axios from 'axios';

const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5000').replace(/\/+$/, '');
const baseURL = API_URL.endsWith('/api') ? API_URL : `${API_URL}/api`;

let _serverDownCallback = null;
let _isServerDown = false;
let _networkErrorCount = 0;

export const onServerDown = (cb) => { _serverDownCallback = cb; };
export const isServerDown = () => _isServerDown;
export const resetServerDown = () => { _isServerDown = false; _networkErrorCount = 0; };

const markServerDown = () => {
  if (!_isServerDown) {
    _isServerDown = true;
    _serverDownCallback?.(true);
  }
};

const markServerUp = () => {
  if (_isServerDown) {
    _isServerDown = false;
    _networkErrorCount = 0;
    _serverDownCallback?.(false);
  }
};

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 10000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    markServerUp();
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }

    const isNetworkError = !error.response && (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED' || error.message?.includes('Network Error'));
    const isUnavailable = error.response?.status === 503 || error.response?.status === 502 || error.response?.status === 504;

    if (isNetworkError || isUnavailable) {
      _networkErrorCount++;
      if (_networkErrorCount >= 1) {
        markServerDown();
      }
    } else {
      markServerUp();
    }

    return Promise.reject(error);
  }
);

export default api;
